/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react';
import useStyles from './style';

import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import Header from 'components/header';
import Footer from 'components/footerUser';
import { Box, Flex, Text } from '@chakra-ui/react';
import ProfilingComplete from '../../assets/img/ProfilingComplete.webp';
import ProfilingStandard from '../../assets/img/ProfilingStandard.webp';
import ProfilingPilihanCareerTerbaik from '../../assets/img/ProfilingPilihanCareerTerbaik.webp';
import ProfilingSifatdanSikapDitempatKerja from '../../assets/img/ProfilingSifatdanSikapDitempatKerja.webp';
import ProfilingHubunganCintadanSosial from '../../assets/img/ProfilingHubunganCintadanSosial.webp';
import MatchingFriendship from '../../assets/img/MatchingFriendship.webp';
import MatchingPartnership from '../../assets/img/MatchingPartnership.webp';
import MatchingRomance from '../../assets/img/MatchingRomance.webp';
import PersonaGeneral from '../../assets/img/PersonaGeneral.webp';
import PersonaDaily from '../../assets/img/PersonaDaily.webp';

const Service = () => {
  const styles = useStyles();

  return (
    <div className={styles.app}>
      <Header active="home" />
      <div className={styles.heroContainer}>
        
      </div>
      <Footer />
    </div>
  );
}

export default Service;